import { render, staticRenderFns } from "./ModalSecretQuestion.vue?vue&type=template&id=09de6086&"
import script from "./ModalSecretQuestion.vue?vue&type=script&lang=js&"
export * from "./ModalSecretQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ModalSecretQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports